export default "__VITE_ASSET__9kFSRdBT__"